import React from 'react';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { HorizontalDivider } from '../dividers';
import { useApi } from '../../context/api-context/use-api';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { COMMENTS_HEADER, HEADER_TITLE } from '../../../common/constants/data-hooks';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { CommentsHeaderRatings } from './comments-header-ratings';
import { UserAuthControl } from '../user-auth-control/user-auth-control';
import { resolveElementAreaClasses } from './comments-header-utils';
import { classes, st } from './comments-header.st.css';
export const CommentsHeader = React.memo(({ commentCount, hideTitle, userAuthControlState, ...props }) => {
    const t = useTranslate();
    const { a11yOptions, headerTitleText } = useConfiguration();
    const isMobile = useApi(getIsMobile);
    const Title = a11yOptions?.headerRank ?? 'span';
    const { titleArea, ratingArea, userAuthArea } = resolveElementAreaClasses({
        isMobile,
        isTitleVisible: !hideTitle,
        isRatingVisible: !props.hideRatings,
        isUserAuthVisible: userAuthControlState.type !== 'HIDDEN',
    });
    return (React.createElement(React.Fragment, null,
        isMobile && React.createElement(HorizontalDivider, { type: "header" }),
        React.createElement("div", { className: st(classes.root, {
                isMobile,
                isOneRow: hideTitle || props.hideRatings || userAuthControlState.type === 'HIDDEN',
            }), "data-hook": COMMENTS_HEADER },
            React.createElement("div", { className: classes.innerContainer },
                !hideTitle && (React.createElement(Title, { className: st(classes.title, titleArea), "data-hook": HEADER_TITLE }, headerTitleText
                    ? headerTitleText(commentCount ?? 0)
                    : t('header.all-comments', {
                        count: commentCount ?? 0,
                    }))),
                userAuthControlState.type !== 'HIDDEN' && (React.createElement("div", { className: st(classes.userAuth, userAuthArea) },
                    React.createElement(UserAuthControl, { ...(userAuthControlState.type === 'LOGOUT'
                            ? {
                                state: 'logout',
                                avatarUrl: userAuthControlState.memberAvatarUrl,
                            }
                            : { state: 'login' }) }))),
                !props.hideRatings && (React.createElement("div", { className: ratingArea },
                    React.createElement(CommentsHeaderRatings, { ...props.ratings })))))));
});
CommentsHeader.displayName = 'CommentsHeader';
//# sourceMappingURL=comments-header.js.map